import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { StockCalendarHeaderRow, StockCalendarRow } from 'components/Calendar'
import { getCalendarArray } from 'lib/calendar'
import { endOfMonth, startOfMonth } from 'date-fns'

type Props = {
  currentDate: Date
  handleCurrentDate: (date: Date) => void
}

const StockCalendar: FC<Props> = (props) => {
  const { currentDate, handleCurrentDate } = props
  const calendar = getCalendarArray(startOfMonth(currentDate), endOfMonth(currentDate))

  return (
    <table className={styles.table}>
      <thead>
        <StockCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <StockCalendarRow key={rowNum} currentDate={currentDate} handleCurrentDate={handleCurrentDate} row={row} />
        ))}
      </tbody>
    </table>
  )
}

export default StockCalendar
